/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Reelplicate API
 * OpenAPI spec version: 1.0
 */

/**
 * Used for new reels and templates.
 */
export type AspectRatio = (typeof AspectRatio)[keyof typeof AspectRatio];

export const AspectRatio = {
  VERTICAL: 'VERTICAL',
  SQUARE: 'SQUARE',
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
} as const;
